/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { LineChartOutlined } from '@ant-design/icons';
import PeriodosFiscales from 'views/LeyDeIngresos/PeriodoFiscal';
import TipoDeRecargo from 'views/LeyDeIngresos/TipoDeRecargo';
import TipoDeCargo from 'views/LeyDeIngresos/TipoDeCargo';
import TiposDeDescuento from 'views/LeyDeIngresos/TiposDeDescuentos';
import ConceptoDeIngresos from 'views/LeyDeIngresos/ConceptoDeIngresos';
import TiposDeActualización from 'views/LeyDeIngresos/TiposDeActualizacion';
import CatalogoDeTarifas from 'views/LeyDeIngresos/CatalogoDeTarifas';
// import TiposDeConvenios from 'views/LeyDeIngresos/TiposDeConvenios';
import TipoDeGasto from 'views/LeyDeIngresos/TipoDeGasto';
import Gastos from 'views/LeyDeIngresos/Gastos';
import DescuentosEspeciales from 'views/LeyDeIngresos/DescuentosEspeciales';
import HistoricoDescuentos from 'views/LeyDeIngresos/HistoricoDescuentos';
// import Descuentos from 'views/LeyDeIngresos/Descuentos';
import TiposDeAlertas from 'views/LeyDeIngresos/TiposDeAlertas';
import Alertas from 'views/LeyDeIngresos/Alertas';
// import Cargos from 'views/LeyDeIngresos/Cargos';
import Cargos from 'views/LeyDeIngresos/Cargos';
import TiposDeDepositosBancarios from 'views/LeyDeIngresos/TipoDeDepositoBancario';
import DepositosBancarios from 'views/LeyDeIngresos/DepositosBancarios';
import { padronesModels, allModelsSearches } from 'utils/permission/models';

const ENV_NAME = process.env.REACT_APP_ENV_NAME;
const ARCOS = ENV_NAME === 'arcos';
const REPUVE = ENV_NAME === 'repuve';
const VENTANILLA = process.env.REACT_APP_ENV_ALTERN === 'ventanilla';

export default
{
  title: 'Ley de Ingresos',
  icon: () => <LineChartOutlined />,
  showInSidebar: true,
  type: 'private',
  children: [
    {
      title: 'Periodo Fiscal',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: PeriodosFiscales,
      permissionModel: 'periodofiscal',
    },
    {
      title: 'Concepto de Ingresos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: ConceptoDeIngresos,
      permissionModel: 'conceptodeingreso',
    },
    {
      title: 'Tipos de Cargo',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TipoDeCargo,
      permissionModel: 'tipodecargo',
    },
    (!REPUVE && !VENTANILLA && !ARCOS) && {
      title: 'Cargos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Cargos,
      permissionModel: 'cargo',
      needJefe: true,
      catalogsModels: [
        ...padronesModels,
        ...allModelsSearches,
        'cargo',
        'tarifa',
        'tipodeaplicacionparacargo',
        'tipodecargo',
        'variable',
      ],
    },
    {
      title: 'Tipos de Recargos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TipoDeRecargo,
      permissionModel: 'tipoderecargo',
    },
    {
      title: 'Tipos de Gasto',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TipoDeGasto,
      permissionModel: 'tipodegasto',
    },
    (!REPUVE && !VENTANILLA && !ARCOS) && {
      title: 'Gastos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Gastos,
      permissionModel: 'gasto',
    },
    {
      title: 'Tipos de Descuentos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TiposDeDescuento,
      permissionModel: 'tipodedescuento',
    },
    // {
    //   title: 'Descuentos',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Descuentos,
    //   permissionModel: 'descuento',
    // },
    (!REPUVE && !VENTANILLA && !ARCOS) && {
      title: 'Descuentos Especiales',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: DescuentosEspeciales,
      permissionModel: 'descuento',
      catalogsModels: [
        ...padronesModels,
        ...allModelsSearches,
      ],
      needJefe: true,
    },
    {
      title: 'Historial de Descuentos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: HistoricoDescuentos,
      permissionModel: 'descuento',
      catalogsModels: [
        ...padronesModels,
        ...allModelsSearches,
      ],
      needJefe: true,
    },
    {
      title: 'Tipos de Actualización',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TiposDeActualización,
      permissionModel: 'tipodeactualizacion',
    },
    {
      title: 'Tipos de Depósitos Bancarios',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TiposDeDepositosBancarios,
      permissionModel: 'tiposdedepositosbancarios',
    },
    {
      title: 'Depósitos Bancarios',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: DepositosBancarios,
      permissionModel: 'depositosbancarios',
    },
    {
      title: 'Catálogo de Tarifas',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CatalogoDeTarifas,
      permissionModel: 'catalogodetarifa',
    },
    {
      title: 'Tipos de Alertas',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: TiposDeAlertas,
      permissionModel: 'tipodealerta',
    },
    (!REPUVE && !VENTANILLA && !ARCOS) && {
      title: 'Alertas',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Alertas,
      permissionModel: 'alerta',
      catalogsModels: [
        'padron',
        'contenttype',
      ],
    },
  ],
};
